import CardFeed from '@ifit/mp-card-feed';
import { DefaultImages } from '@ifit/img/out/defaults';
import cn from 'classnames';
import { ILiveWorkoutAndDetails } from '.';
import { formatLiveWorkoutStartTime, isInPast } from '../../util/date-utils';
import { useLanguage } from '../../state-management/selectors/use-language';
import { getUserNavigationHandler, ROWTITLES } from '../../util/navigation-utils';
import { useRerenderOnTimer } from '../../util/use-rerender-on-timer';
import { ONE_SECOND } from '../../util/durations';
import { getResizedImageUrl } from '../../util/get-resized-image-url';

interface ILiveWorkoutItemProps {
  item: ILiveWorkoutAndDetails;
}

export default function LiveWorkoutItem(props: ILiveWorkoutItemProps): JSX.Element {
  const language = useLanguage();
  const { liveWorkout, userWorkoutDetail } = props.item;
  const timestamp = liveWorkout.schedule.airDateStartTime;
  useRerenderOnTimer(ONE_SECOND);

  const startTimeString = formatLiveWorkoutStartTime(language, timestamp);
  const clickHandler = getUserNavigationHandler(liveWorkout.schedule.url, ROWTITLES.LIVE_WORKOUT_ITEM);

  const imageUrl = getResizedImageUrl(liveWorkout.workout.imageUrl, DefaultImages.LargeCard, {
    width: 560,
    height: 360,
  });

  return (
    <CardFeed
      title={liveWorkout.workout.title}
      imageUrl={imageUrl}
      onClick={clickHandler}
      tagPrimary={startTimeString}
      live
      locked={userWorkoutDetail?.locked}
      className={cn({ upcoming: !isInPast(timestamp) })}
    />
  );
}
